
import EDMenuText from '../../MenuText/EDMenuText';
import EDTypography from '../../Typography/EDTypography';
import EDTooltip from '../../Tooltip/EDTooltip';
import { getSelectChoiceNameFromValue, ISelectChoice } from '../SelectCommons';
import EDIcon from '../../Icon/EDIcon';
import { makeStyles } from 'tss-react/mui';

import EDSelectMenuItem from '../EDSelectMenuItem';

interface IProps<T extends string | number | boolean | object> {
  currentValue?: T;
  onChange: (newValue: T) => void;
  items: Array<ISelectChoice<T>>;
  textWrap?: boolean;
  label?: string;
  labelColor?:
    | 'initial'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'textPrimary'
    | 'textSecondary'
    | 'error';
  labelTooltip?: string;
  displayDropdownArrow?: boolean;
  disabled?: boolean;
  value?: T;
}

const useStyles = makeStyles()(theme => ({
  labelContainer: {
    cursor: 'pointer',
  },
  disabled: {
    cursor: 'inherit',
    color: theme.palette.common.white,
    opacity: 0.26, // FIXME: normalt är disabled 0.38, men det kan finnas anledning att diskutera det.
  },
  labelSubContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  typography: {
    display: 'inline',
    whiteSpace: 'nowrap',
  },
  textWrap: {
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineHeight: '32px' /* fallback */,
    maxHeight: theme.spacing(8) /* fallback */,
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  label: {
    paddingRight: theme.spacing(0.5),
  },
}));

// TODO: HOCS tappar bort generic typer, så kan inte använda withStyles. Borde kunna ta bort style properties när vi använder material-ui hooks
/**
 * Komponent för att visa ett select field som text. Vid klick på texten kommer en meny upp där man får valmöjligheterna
 */
const EDTextSelect = <T extends string | number | boolean | object>(
  props: IProps<T>
) => {
  const selected = props.items.reduce((a, b, index) => {
    if (b.value === props.currentValue) {
      a = index;
    }
    return a;
  }, 0);

  const { classes, cx } = useStyles();

  return (
    <div>
      <EDMenuText
        label={
          <div
            className={cx(classes.labelContainer, {
              [classes.disabled]: props.disabled,
            })}
          >
            <EDTooltip title={props.labelTooltip}>
              <div className={classes.labelSubContainer}>
                {props.label && (
                  <EDTypography
                    className={cx(classes.typography, classes.label)}
                    bold
                    color={props.labelColor ?? 'inherit'}
                  >
                    {props.label}:{' '}
                  </EDTypography>
                )}
                <EDTypography
                  className={cx(classes.typography, {
                    [classes.textWrap]: props.textWrap,
                  })}
                  variant="body2"
                  color={props.labelColor ?? 'inherit'}
                >
                  {getSelectChoiceNameFromValue(
                    props.currentValue,
                    props.items
                  )}
                </EDTypography>
                {props.displayDropdownArrow && (
                  <EDIcon
                    color="inherit"
                    marginRight={!props.textWrap ? 1 : undefined}
                    iconType={'arrow_drop_down'}
                  />
                )}
              </div>
            </EDTooltip>
          </div>
        }
        selected={selected}
        disabled={props.disabled}
      >
        {props.items.map((item, i) => (
          <EDSelectMenuItem
            key={i}
            onChange={props.onChange}
            item={item}
            currentValue={props.currentValue}
          />
        ))}
      </EDMenuText>
    </div>
  );
};

export default EDTextSelect;
